// (Parceiros)
export const FILTER_PARTNER_GET_ALL = 702
// REDES
export const FILTER_GEOGRAPHY_NETWORK_GET_ALL = 703
// Filiais
export const FILTER_GEOGRAPHY_SUBSIDIARY_GET_ALL = 704
// Grupos de Lojas
export const FILTER_STORE_GROUP_GET_ALL = 705
// Matriz de prioridades
export const FILTER_STORE_PRIORITY_MATRICES_GET_ALL = 706
// Produtos da loja
export const FILTER_STORE_PRODUCT_GET_ALL = 707
// Segmentos da loja
export const FILTER_STORE_SEGMENT_GET_ALL = 708
// Status da loja
export const FILTER_STORE_STATUS_GET_ALL = 709

// Listagem de lojas disponíveis
export const FILTERS_STORES_AVAILABLE_GET_ALL = 141
export const UPDATE_STORES_SUPERVISED = 143
export const SHOW_DETAIL_SUPERVISED = 138

// @TODO alterar para o correto
export const SHOW_LIST_WALLET_SUPERVISED = 145

export const ALL_ROLES = [
  FILTER_PARTNER_GET_ALL,
  FILTER_GEOGRAPHY_NETWORK_GET_ALL,
  FILTER_GEOGRAPHY_SUBSIDIARY_GET_ALL,
  FILTER_STORE_GROUP_GET_ALL,
  FILTER_STORE_PRIORITY_MATRICES_GET_ALL,
  FILTER_STORE_PRODUCT_GET_ALL,
  FILTER_STORE_SEGMENT_GET_ALL,
  FILTER_STORE_STATUS_GET_ALL
]
